import { Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { useEffect } from 'react'

import { getTranslate } from '../../localization'
import useStyles from './styles/PriceClassDistributionRoomtypeRow.styles'

interface PriceClassDistributionRoomtypeRowProps {
  name: string
  numberOfRatePlans: number
  showRatePlan: boolean
  setShowRatePlan: React.Dispatch<React.SetStateAction<boolean>>
  openAll: boolean
  setOpenAll: React.Dispatch<React.SetStateAction<boolean>>
  weekendIndexes: number[]
  range: 'TWO_WEEKS' | 'MONTH'
}

const PriceClassDistributionRoomtypeRow: React.FC<
  PriceClassDistributionRoomtypeRowProps
> = ({
  name,
  numberOfRatePlans,
  showRatePlan,
  setShowRatePlan,
  openAll,
  setOpenAll,
  weekendIndexes,
  range
}) => {
  const classes = useStyles()

  useEffect(() => {
    if (!showRatePlan) {
      setOpenAll(false)
    }
  }, [showRatePlan])

  return (
    <div
      className={[
        classes.roomTypeRow,
        range === 'MONTH' && classes.roomTypeRowForMonth
      ].join(' ')}>
      <div className={classes.rowNameContainer}>
        <div className={classes.roomIcon} onClick={() => setOpenAll(!openAll)}>
          <ArrowRightIcon
            className={[
              classes.openAllArrowRight,
              openAll ? classes.openAllArrowDown : ''
            ].join(' ')}
          />
        </div>
        <Typography variant="h4" className={classes.rowName}>
          {name}
        </Typography>{' '}
        <Typography
          variant="h6"
          className={classes.numberOfRatePlans}
          component="span"
          onClick={() => setShowRatePlan(!showRatePlan)}>
          {numberOfRatePlans} {getTranslate('Rate Plans')}
        </Typography>
        <div className={classes.ratePlansLoading}>
          <ArrowRightIcon
            className={[
              classes.roomTypeArrowRight,
              showRatePlan ? classes.roomTypeArrowDown : ''
            ].join(' ')}
          />
        </div>
      </div>
      <div />
      {Array(range === 'TWO_WEEKS' ? 14 : 30)
        .fill(' ')
        .map((_, index) => (
          <div
            key={index}
            className={[
              classes.emptyBox,
              weekendIndexes.includes(index % 7)
                ? classes.weekendDayContainer
                : ''
            ].join(' ')}
          />
        ))}
    </div>
  )
}

export default PriceClassDistributionRoomtypeRow
